export function DashboardPage() {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h1 className="text-2xl font-bold mb-6">Панель администратора</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-blue-50 p-4 rounded-lg">
          <h3 className="font-semibold text-blue-800">Клиенты</h3>
          <p className="text-blue-600">Управление клиентами</p>
        </div>
        <div className="bg-green-50 p-4 rounded-lg">
          <h3 className="font-semibold text-green-800">Организации</h3>
          <p className="text-green-600">Управление организациями</p>
        </div>
        <div className="bg-purple-50 p-4 rounded-lg">
          <h3 className="font-semibold text-purple-800">Статистика</h3>
          <p className="text-purple-600">Общая статистика</p>
        </div>
      </div>
    </div>
  );
}
